import { isValidElement, type ReactNode } from "react";
import { CollapsibleSection } from "@/components/ui/detail-card";
import type { Box } from "@/components/ui/box.schema";
import type { VisitSection } from "@/lib/visit/registry";

/** Ordered presentation only. Unlisted boxes and original native nodes survive. */
export function VisitSections({ sections, nodes, opens = [] }: { sections: VisitSection[]; nodes: ReactNode[]; opens?: string[] }) {
  const idOf = (node: ReactNode) => isValidElement<{ box?: Box; "data-box-id"?: string }>(node) ? node.props.box?.id ?? node.props["data-box-id"] : undefined;
  const available = new Map(nodes.map((node) => [idOf(node), node]));
  const sectionIds = new Set(sections.flatMap(section => section.boxIds));
  const firstSection = nodes.findIndex(node => sectionIds.has(idOf(node) ?? ""));
  const leading = nodes.slice(0, firstSection < 0 ? nodes.length : firstSection);
  const grouped = new Set<string>();
  return <div className="flex min-w-0 flex-col gap-3" data-record-sections="">
    {leading}
    {sections.map((section) => {
      const ids = section.boxIds.filter((id) => available.has(id) && !grouped.has(id));
      ids.forEach((id) => grouped.add(id));
      if (!ids.length) return null;
      return <div key={section.id} data-record-section={section.id}><CollapsibleSection icon={section.icon} label={section.label} summary={section.summary} defaultOpen={section.defaultOpen || ids.some((id) => opens.includes(id))}>
        {ids.map((id) => available.get(id))}
      </CollapsibleSection></div>;
    })}
    {nodes.filter((node) => !leading.includes(node) && !grouped.has(idOf(node) ?? ""))}
  </div>;
}
